import api from '@/services/api';

export async function getCurrentSchoolYear() {
  // Erwartet ein Objekt zum aktuellen Schuljahr
  // Beispielhafte Felder: title | name | label | code | school_year
  const res = await api.get('/school-years/current').then(r => r.data);
  return res;
}
